import { render, staticRenderFns } from "./CCButtonUploadFile.vue?vue&type=template&id=19a1b07a"
import script from "./CCButtonUploadFile.vue?vue&type=script&lang=js"
export * from "./CCButtonUploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports